import { Autocomplete, TextField } from "@mui/material";
import { useFileExplorerContext } from "../FileExplorerContext";
import { UploadedFileType } from "./uploadedFileType";

export const SelectFileTypeDropdown = () => {
  const { selectedFileType, setSelectedFileType, fileTypeOptions } =
    useFileExplorerContext();

  return (
    <Autocomplete
      value={selectedFileType}
      onChange={(_, newValue) => {
        setSelectedFileType(newValue ?? ("unknown" as UploadedFileType));
      }}
      options={fileTypeOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select or search file type..."
          size="small"
        />
      )}
      size="small"
      sx={{ minWidth: 250 }}
    />
  );
};
